// extracted by mini-css-extract-plugin
module.exports = {"iconListTitle":"icon-list_iconListTitle__NqW4b","iconsListWrapper":"icon-list_iconsListWrapper__FGcky","large":"icon-list_large__KCRyu"};